export const GET_CONTRACT_LISTING0 = 'GET_CONTRACT_LISTING0';

export const dashboardActions = {
  expandListItem: 'EXPAND_LIST_ITEM',
  collapseListItem: 'COLLAPSE_LIST_ITEM',
  selectListItem: 'SELECT_LIST_ITEM',
  selectAllListItems: 'SELECT_ALL_LIST_ITEMS',
  checkOneContract: 'CHECK_ONE_CONTRACT',
  checkAllContracts: 'CHECK_ALL_CONTRACTS',
  uncheckOneContract: 'UNCHECK_ONE_CONTRACT',
  uncheckAllContracts: 'UNCHECK_ALL_CONTRACTS',
  checkAllLocations: 'CHECK_ALL_LOCATIONS',
  uncheckAllLocations: 'UNCHECK_ALL_LOCATIONS',
  checkOneLocation: 'CHECK_ONE_LOCATION',
  uncheckOneLocation: 'UNCHECK_ONE_LOCATION',
  searchContracts: 'FILTER_BY_SEARCH_FRONT_END',
  expandCompanyInContractListing: 'EXPAND_COMPANY_IN_CONTRACT_LISTING',
  sortCompanyNameFnInContractListing: 'SORT_COMPANY_NAME_IN_CONTRACT_LISTING',
  toggleTimeStampFn: 'TOGGLE_TIME_STAMP_IN_CONTRACT_LISTING',
};



// WEBPACK FOOTER //
// ./src/app/stores/contracting/dashboard/dashboard-constants.js